function roundOff(number, precision = 2) {
  return Number(number).toFixed(precision);
}

export { roundOff };
